import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Transforms an Auxo CDN image URL to use Cloudflare on-the-fly resizing.
 * @param {string} url - The original image URL.
 * @param {number} width - Desired width.
 * @param {number} quality - Image quality (1-100).
 * @returns {string} The transformed URL.
 */
export function getResizedImageUrl(url, width = 600, quality = 80) {
  if (!url) return ''
  if (url.startsWith('https://assets.auxodev.dk/')) {
    if (url.includes('/cdn-cgi/image/')) return url
    return url.replace(
      'https://assets.auxodev.dk/',
      `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
    )
  }
  return url
}
